module.exports = __webpack_public_path__ + "img/Protractor-04.b750f99f.png";